var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-header',{attrs:{"height":"70"}},[(!_vm.headerpage)?_c('page-header'):_vm._e()],1),_c('el-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }